export default {
  name: "Strongbow",
  favicon: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/logo.webp`,
  logo: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/logo.webp`,
  logoColor: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/logo-color.webp`,
  products: [
    {
      id: "dry",
      image: {
        en: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/en/product-foward_originaldry.webp`,
        fr: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/fr/product-foward_originaldry.webp`,
      },
      name: {
        en: "Original Dry",
        fr: "Original Dry",
      },
      description: {
        en: "An original classic by any name. A perfectly balanced English apple cider that is light in body, crisp, and refreshingly dry. Best enjoyed over ice. 5.3% ABV.",
        fr: "Un classique original, sous toutes ses formes. Un cidre de pomme anglais parfaitement équilibré, léger en bouche, vif et agréablement sec. À déguster idéalement sur glace. Degré d'alcool : 5,3 %.",
      },
      formats: [
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/en/information_render_bottle_330ml_originaldry_strongbow.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/fr/information_render_bottle_330ml_originaldry_strongbow.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/en/information_nft_allrenders_originaldry_strongbow.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/fr/information_nft_allrenders_originaldry_strongbow_fr.webp`,
          },
          name: {
            en: "Bottle 330ml",
            fr: "Bouteille 330ml",
          },
        },
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/en/information_render_can_440ml_originaldry_strongbow.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/fr/information_render_can_440ml_originaldry_strongbow.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/en/information_nft_allrenders_originaldry_strongbow.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/fr/information_nft_allrenders_originaldry_strongbow_fr.webp`,
          },
          name: {
            en: "Can 440ml",
            fr: "Canette 440ml",
          },
        },
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/en/information_render_can_500ml_originaldry_strongbow.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/fr/information_render_can_500ml_originaldry_strongbow.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/en/information_nft_allrenders_originaldry_strongbow.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/fr/information_nft_allrenders_originaldry_strongbow_fr.webp`,
          },
          name: {
            en: "Can 500ml",
            fr: "Canette 500ml",
          },
        },
      ],
    },
    // {
    //   id: "darkfruit",
    //   image: {
    //     en: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/en/product-foward_ultradarkfruit.webp`,
    //     fr: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/fr/product-foward_ultradarkfruit.webp`,
    //   },
    //   name: {
    //     en: "Ultra Dark Fruit",
    //     fr: "Ultra Dark Fruit",
    //   },
    //   description: {
    //     en: "...",
    //     fr: "...",
    //   },
    //   formats: [
    //     {
    //       image: {
    //         en: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/en/information_render_can_330ml_ultradarkfruit_strongbow.webp`,
    //         fr: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/fr/information_render_can_330ml_ultradarkfruit_strongbow.webp`,
    //       },
    //       details: {
    //         en: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/en/information_nft_can_330ml_ultradarkfruit_strongbow.webp`,
    //         fr: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/fr/information_nft_can_330ml_ultradarkfruit_strongbow_fr.webp`,
    //       },
    //       name: {
    //         en: "Can 440ml",
    //         fr: "Canette 440ml",
    //       },
    //     },
    //   ],
    // },
    {
      id: "gold",
      image: {
        en: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/en/product-foward_gold.webp`,
        fr: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/fr/product-foward_gold.webp`,
      },
      name: {
        en: "Gold",
        fr: "Gold",
      },
      description: {
        en: "Strongbow Gold Apple pairs well with sweet and savoury snacks. These yummy treats will tickle your taste buds.",
        fr: "Strongbow Gold Apple se marie bien avec des en-cas sucrés et salés. Ces gâteries stimuleront vos papilles.",
      },
      formats: [
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/en/information_render_can_400ml_gold_strongbow.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/fr/information_render_can_400ml_gold_strongbow.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/en/information_nft_can_440ml_gold_strongbow.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/fr/information_nft_can_440ml_gold_strongbow_fr.webp`,
          },
          name: {
            en: "Can 440ml",
            fr: "Canette 440ml",
          },
        },
      ],
    },
    // {
    //   id: "ultramango",
    //   image: {
    //     en: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/en/product-foward_ultramango.webp`,
    //     fr: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/fr/product-foward_ultramango.webp`,
    //   },
    //   name: {
    //     en: "Ultra Mango",
    //     fr: "Ultra Mango",
    //   },
    //   description: {
    //     en: "Strongbow Ultra Mango cider is a refreshingly light cider with 95 calories, 4% ABV and natural mango flavours, all served up in a sleek new 330ml slimline can. An exciting new kind of lower calorie cider that doesn't compromise on great taste.",
    //     fr: "Le cidre Strongbow Ultra Mango est un cidre agréablement léger avec 95 calories, 4% ABV et des saveurs naturelles de mangue, le tout servi dans une élégante canette slimline de 330 ml. Un nouveau type de cidre à faible teneur en calories qui ne fait pas de compromis sur le goût exceptionnel.",
    //   },
    //   formats: [
    //     {
    //       image: {
    //         en: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/en/information_render_can_330ml_ultramango_strongbow.webp`,
    //         fr: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/fr/information_render_can_330ml_ultramango_strongbow.webp`,
    //       },
    //       details: {
    //         en: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/en/information_nft_can_330ml_ultramango_strongbow.webp`,
    //         fr: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/fr/information_nft_can_330ml_ultramango_strongbow_fr.webp`,
    //       },
    //       name: {
    //         en: "Can 330ml",
    //         fr: "Canette 330ml",
    //       },
    //     },
    //   ],
    // },
    // {
    //   id: "ultraapple",
    //   image: {
    //     en: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/en/product-foward_ultraapple.webp`,
    //     fr: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/fr/product-foward_ultraapple.webp`,
    //   },
    //   name: {
    //     en: "Ultra Apple",
    //     fr: "Ultra Apple",
    //   },
    //   description: {
    //     en: "...",
    //     fr: "...",
    //   },
    //   formats: [
    //     {
    //       image: {
    //         en: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/en/information_render_can_330ml_ultraapple_strongbow.webp`,
    //         fr: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/fr/information_render_can_330ml_ultraapple_strongbow.webp`,
    //       },
    //       details: {
    //         en: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/en/information_nft_can_330ml_ultraapple_strongbow.webp`,
    //         fr: `${process.env.REACT_APP_AZURE_STORAGE}/strongbow/fr/information_nft_can_330ml_ultraapple_strongbow_fr.webp`,
    //       },
    //       name: {
    //         en: "Can 330ml",
    //         fr: "Canette 330ml",
    //       },
    //     },
    //   ],
    // },
  ],
};
